import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import Typography from "@mui/joy/Typography";

import useSubscription from "hooks/useSubscription";
import { SubscriptionType } from 'stores/subscription_store';

import Table from '@mui/joy/Table';
import Chip from '@mui/joy/Chip';
import Card from '@mui/joy/Card';

import DateUI from 'components/Date';
import useUserIdentity from "hooks/useUserIdentity";
import useAuth from "hooks/useAuth";

const SubscriptionList = observer(() => {
    const {
        fetchListByIdentitySubscription,
        getListByUserSubscription
    } = useSubscription();
    const [items, setItems] = useState([] as SubscriptionType[]);
    const { currentIdentity } = useUserIdentity();
    const { currentUser } = useAuth();

    useEffect(() => {
        if (currentIdentity?.key) {
            fetchListByIdentitySubscription(currentIdentity.key)
                .then(() => {
                    const i = getListByUserSubscription(currentUser?.uuid);
                    setItems(i);
                })
        }

    }, [fetchListByIdentitySubscription, currentIdentity?.key, currentUser?.uuid, setItems]);

    return (
        <Card>
        <Typography level="title-lg">Subscriptions</Typography>
        <Table>
            <thead>
                <tr>
                    <th>Date Updated</th>
                    <th>Plan</th>
                    <th>Status</th>
                </tr>
            </thead>

            {items.map( i =>
                <tr key={i.uuid}>
                    <td>
                        <DateUI dateString={i.date_updated} />
                    </td>
                    <td>
                        {i.plan_name}
                    </td>

                    <td>
                        <Chip color={i.service_subscription_status == 'active' ? 'success' : 'neutral'}>
                            {i.service_subscription_status}
                        </Chip>
                    </td>
                </tr>
            )}
        </Table>
        </Card>
    );
 });


export default SubscriptionList;
